$ = require 'jquery'
Singleton = require '../../pattern/singleton'
Data = require '../data'
Elements = require './elements'
Loader = require './loader'
{ forEach, map, flatten, clone } = require 'lodash'
{ toAngle, getRandom, getDir, getHypotenuse } = require '../../components/math'

module.exports =
class HeroBg extends Singleton

  selector : '.section-hero .bg'
  defColors: [ 0xffffff, 0x92defe, 0xfddd34 ]
  widthMin : 10
  widthMax : 30

  constructor: ->
    super

    @$window = Elements.$window
      .one
        'pagesLoaded'    : @onPagesLoaded
        'worksListSetted': @onWorksListSetted

    @setViews()
    @interval        = getHypotenuse @widthMax, toAngle(45)
    @isAnimeEnded    = false
    @colors          = clone @defColors
    @stripeX         = []
    @stripeW         = @widthMin
    @imageLoadedRate = 0

    @loader = Loader.getInstance()

  onPagesLoaded: =>
    @$visualizer = $ @selector

    @$window.on 'resize', @resize

    @stage    = new PIXI.Container
    @renderer = new PIXI.autoDetectRenderer @viewW, @viewH, { backgroundColor: 0xffffff }
    @$visualizer.append @renderer.view

    @momentGroup = new PIXI.Container
    @stage.addChild @momentGroup

    @renderer.render @stage

  onWorksListSetted: =>
    @reset()
    @stripeLen = @getStripeLen()
    if Math.floor(@stripeLen / 4) % 2
      @colors[1] = @defColors[2]
      @colors[2] = @defColors[1]
    @create()

    @progressBarDraw()
    @progressBarAnime1()
    requestAnimationFrame @animate

  resize: =>
    stripeLen = @getStripeLen()
    @reset()

    if @stripeLen isnt stripeLen
      return unless @isAnimeEnded
      @stripeLen = @getStripeLen()
      forEach @stripe, (graphic) =>
        graphic.square.clear()
      @stripe = map [0...@stripeLen], @createSquare
      @stripeDraw()
    else
      h = @getSquareH()
      forEach @stripe, (graphic) =>
        graphic.square.height = h

    unless @isAnimeEnded
      progressBarPos = @getProgressBarPos()
      square         = @progressBar.square
      square.x       = -progressBarPos
      square.y       = progressBarPos
      square.height  = @getSquareH()
      square.mask    = null

      mask           = @progressBar.mask
      mask.x         = -@viewMin
      mask.y         = @viewMin
      mask.height    = @viewH

      square.mask    = mask

    @renderer.render @stage

  reset: ->
    @setViews()

    @renderer.resize @viewW, @viewH

    @momentGroup.x = @renderer.width / 2
    @momentGroup.y = @renderer.height / 2

  setViews: ->
    @viewW   = Math.max @$window.width(), Data.minWidth
    @viewH   = Math.max @$window.height(), Data.minHeight[0]
    @viewMax = Math.max @viewW, @viewH
    @viewMin = Math.min @viewW, @viewH

  getStripeLen: ->
    len = Math.ceil (getHypotenuse @viewMax, toAngle(45)) / @widthMax
    len + (4 - ((len - 3) % 4))

  getSquareH: ->
    getHypotenuse (@viewH + @widthMax), toAngle(45)

  getProgressBarPos: ->
    @viewMin - (@viewMin * @imageLoadedRate)

  ###
  create
  ###
  create: ->
    @moment = new PIXI.Container
    @momentGroup.addChild @moment
    @stripe      = map [0...@stripeLen], @createSquare
    @progressBar = @createSquare true

  ###
  create square
  ###
  createSquare: (isCreateMask = false) =>
    square          = new PIXI.Graphics
    square.pivot.x  = 50
    square.pivot.y  = 50
    square.rotation = toAngle 45
    @moment.addChild square

    if isCreateMask
      mask = new PIXI.Graphics
      @moment.addChild mask
    else
      mask = null

    { square: square, mask: mask }

  ###
  progress bar draw
  ###
  progressBarDraw: ->

    square = @progressBar.square
      .beginFill @defColors[1]
      .drawRect 0, 0, 100, 100
      .endFill()
    square.width  = @widthMin
    square.height = @getSquareH()
    square.x      = -@viewMin
    square.y      = @viewMin

    mask = @progressBar.mask
      .beginFill 0x000000
      .drawRect 0, 0, @viewW, @viewH
      .endFill()
    mask.pivot.x = @viewW / 2
    mask.pivot.y = @viewH / 2
    mask.x       = -@viewMin
    mask.y       = @viewMin

    square.mask = mask

  ###
  stripe draw
  ###
  stripeDraw: ->
    shiftX = @interval * Math.floor(@stripeLen / 2)
    w =
      unless @isAnimeEnded then @widthMin else @widthMax

    forEach @stripe, (graphic, i) =>

      color =
        if i % 2
          if ((i - 1) / 2) % 2 then 2 else 1
        else
          0

      x =
        unless @isAnimeEnded then 0 else ((@interval * i) - shiftX)

      square = graphic.square
        .beginFill @colors[color]
        .drawRect 0, 0, 100, 100
        .endFill()
      square.width  = w
      square.height = @getSquareH()
      square.x      = x
      square.y      = 0

  ###
  animate
  ###
  animate: =>
    @renderer.render @stage
    return if @isAnimeEnded
    requestAnimationFrame @animate

  ###
  progress bar anime 1
  ###
  progressBarAnime1: ->
    @imageLoadedRate = @loader.getImageLoadedRate()
    progressBarPos   = @getProgressBarPos()

    x = -progressBarPos
    y = progressBarPos

    squaresTL = new TimelineMax
      onComplete: =>
        if 1 > @imageLoadedRate
          @progressBarAnime1()
        else
          @stripeDraw()
          @progressBarAnime2()

    squaresTL
      .add TweenMax.to @progressBar.square, 1,
        x   : x
        y   : y
        ease: Power4.easeOut

    masksTL = new TimelineMax

    masksTL
      .add TweenMax.to @progressBar.mask, 1,
        x   : x
        y   : y
        ease: Power4.easeOut

  ###
  progress bar anime 2
  ###
  progressBarAnime2: ->
    tl = new TimelineMax
      onComplete: =>
        @spriteAnime()

    tl
      .add TweenMax.to @progressBar.square, .5,
        width: @widthMax
        ease : Power4.easeIn

  ###
  spraite anime
  ###
  spriteAnime: ->
    @completedCount = 0

    shiftX = @interval * Math.floor(@stripeLen / 2)

    forEach @stripe, (graphic, i) =>
      square   = graphic.square
      x        = (@interval * i) - shiftX

      squaresTL = new TimelineMax
        onComplete: =>
          @completedCount++
          if @stripeLen is @completedCount
            @progressBar.square.clear()
            @progressBar.mask.clear()
            @isAnimeEnded = true
            @$window.trigger 'heroBgEnded'
            @resize()

      squaresTL
        .add TweenMax.to square, .7,
          x    : x
          width: @widthMax
          ease : Power0.none



// WEBPACK FOOTER //
// ./webpack/requires/pc/views/hero-bg.coffee